import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { usePlayer } from '../../hooks/PlayerProvider';
import { useIcons } from '../../hooks/useIcons';

export const ReplayButton: FunctionComponent<IconButtonProps> = (props) => {
  const player = usePlayer();
  const { Replay } = useIcons();

  const handleClick = useCallback(() => {
    player.play();
  }, [player]);

  return (
    <IconButton onClick={handleClick} {...props}>
      <Replay />
    </IconButton>
  );
};
